import { render, staticRenderFns } from "./OtpAcknowledgement.vue?vue&type=template&id=6a2de2f8&"
import script from "./OtpAcknowledgement.vue?vue&type=script&lang=js&"
export * from "./OtpAcknowledgement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports